import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { PatientProfileInfoAccordion } from '../PatientProfileInfoAccordion';
import { ContactInfoRow } from '../../../../../molecules';
import { Insurance, InsuranceCompany } from '@uplift/api';
import { CamelCaseKeys } from '@uplift/types';


export type InsuranceAccordionProps = {
  insurances?: {
    insurance: CamelCaseKeys<Pick<Insurance, 'id' | 'subscriberId' | 'groupNumber' | 'isSecondaryInsurance'>>;
    insuranceCompany?: CamelCaseKeys<Pick<InsuranceCompany, 'logoUrl' | 'name' | 'shortName'>>;
  }[];
};


export const InsuranceAccordion: React.VFC<InsuranceAccordionProps> = (props) => {
  if (!props.insurances) {
    return (
      <PatientProfileInfoAccordion
        title="Insurance"
        chip={<Chip size="small" label="None" />}
      />
    );
  }

  if (props.insurances.length === 0) {
    return (
      <PatientProfileInfoAccordion
        title="Insurance"
        compensateExpandableIcon
        chip={<Chip size="small" label="Cash pay" />}
      />
    );
  }

  if (props.insurances.length === 1) {
    const { insurance, insuranceCompany } = props.insurances[0];

    return (
      <PatientProfileInfoAccordion
        title="Insurance"
        chip={insuranceCompany && (
          <img height="18px" alt={insuranceCompany.name} src={insuranceCompany.logoUrl} />
        )}
      >
        <Box display="flex" flexDirection="column" gap="8px">
          {insuranceCompany && <Typography>{insuranceCompany.shortName}</Typography>}
          <ContactInfoRow primary={insurance.subscriberId} secondary="member ID" />
          {insurance.groupNumber && <ContactInfoRow primary={insurance.groupNumber} secondary="group number" />}
        </Box>
      </PatientProfileInfoAccordion>
    );
  }

  return (
    <PatientProfileInfoAccordion
      title="Insurance"
      chip={(
        <Chip size="small" label={props.insurances.length} />
      )}
    >
      <Box display="flex" flexDirection="column" gap="8px">
        {props.insurances.map(({ insurance, insuranceCompany }) => (
          <Box key={insurance.id} display="flex" flexDirection="column" gap="8px">
            <Typography color="secondary" variant="overline">
              {insurance.isSecondaryInsurance ? 'Secondary' : 'Primary'}
            </Typography>
            {insuranceCompany && <Typography>{insuranceCompany.shortName}</Typography>}
            <ContactInfoRow primary={insurance.subscriberId} secondary="member ID" />
            {insurance.groupNumber && <ContactInfoRow primary={insurance.groupNumber} secondary="group number" />}
          </Box>
        ))}
      </Box>
    </PatientProfileInfoAccordion>
  );
};
